import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import Header_1 from '../headers/Header_1';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import Formulare from '../modules/Formulare';
import SEO from '../components/Seo';
import Button from '../components/Button';
import FaqMoldule from '../modules/FaqModule';

export const AktuellesDetail = () => {

    let { title } = useParams();
    const navigate = useNavigate();

    const [show, setShow] = useState(false);
    const faqData = [
        {
            id: "accordion1",
            items: [
                { id: "v1", question: "Proin gravida nibh vel velit auctor aliquet", answer: "Antwort..." },
                { id: "v2", question: "Nibh vel velit auctor aliquet. Aenean sollicitudin", answer: "Antwort..." },
                { id: "v3", question: "Aenean sollicitudin, lorem quis bibendum aucto", answer: "Antwort..." },
                { id: "v4", question: " Nam nec tellus a odio tincidunt auctor a ornare odio", answer: "Antwort..." }
            ]
        }
    ];

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [aktuelles, setAktuelles] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);
    

    useEffect(() => {
        const equalHeight = () => {
            const elements = document.querySelectorAll(
                ".sec-related-aktuelles h4"
            );

            let maxHeight = 0;

            elements.forEach((el) => {
                el.style.height = "auto"; // reset
                maxHeight = Math.max(maxHeight, el.offsetHeight);
            });

            elements.forEach((el) => {
                el.style.height = maxHeight + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 500);

        // run on resize
        window.addEventListener("resize", equalHeight);

        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, [modules]);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/aktuelles?populate[aktuelles_kategorie][populate]=*&populate[Bannerbereich][on][header.header-1-titel-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Video][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][FAQ][populate]=*&populate[Modul][on][modules.bilder-und-videos][populate][Bilder][populate]=*&populate[Modul][on][modules.bilder-und-videos][populate][Video][populate]=*&populate[Modul][on][modules.bilder-und-videos][populate][Videominiaturansicht][populate]=*&populate[Modul][on][modules.faq][populate][FAQ_Data][populate]=*&populate[Metadaten]=*");


            // ?populate[Bannerbereich][on][header.header-1-titel-text][populate][Button]=true

            // &populate[aktuelles_kategorie][populate]=*
            // &populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Bild]=true
            // &populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][PDF]=true
            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][siedlungen_kategorien][populate]=*

            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data);

            if (data.data) {
                setAktuelles(data.data);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    const [metaData, setMetaData] = useState(null);

    useEffect(() => {

        if (aktuelles?.length > 0 && title) {
            const matchedCategory = aktuelles?.find((category) => category.slug === title);
            if (matchedCategory) {
                setModules(matchedCategory?.Modul);
                setHeaderModules(matchedCategory?.Bannerbereich);

                setMetaData(matchedCategory?.Metadaten);

            } else {
                navigate("/error"); // Redirect to trigger the catch-all error route
            }
        }


    }, [aktuelles, title]);

    const truncateBlocks = (blocks, maxLength = 120) => {
        if (!blocks) return "";

        let text = "";

        for (let block of blocks) {
            if (block.children) {
                for (let child of block.children) {
                    text += child.text;

                    if (text.length >= maxLength) {
                        return text.slice(0, maxLength) + "...";
                    }
                }
            }
        }

        return text;
    };

    useEffect(() => {
        getPageData();
    }, [])

    const videoRef = useRef(null);
    const [play, setPlay] = useState(false);

    const playVideo = () => {
        setPlay(true);
    }

    const pauseVideo = () => {
        setPlay(false);
    }

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hovering, setHovering] = useState(false);

    const mouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        setPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-1-titel-text" && (
                            <Header_1 title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-aktuelles-pages" activePage="aktuelles" />
                        )}
                    </React.Fragment>
                ))
            )}


            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="orange" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} faqData={module?.FAQ} showFaq={module?.Hat_Akkordeon_Daten === "Ja"} />
                        }
                        {module.__component === "modules.formulare-reglemente-dokumente" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <DokumenteSlider formulare={module?.formulares} /> */}
                                    <Formulare formulare={module?.formulares} />
                                </div>
                            </section>}
                        {module.__component === "modules.faq" &&
                            <FaqMoldule module={module} sectionColor='pink' />
                        }
                        {module.__component === "modules.bilder-und-videos" &&
                            <section className={`pt-pb-10 sec-pink-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {module?.Bild_oder_Video === "Video" ? (
                                        <div className={`video_thumbnail position-relative ${hovering && play ? 'hide_cursor' : ''}`} onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)} onMouseMove={mouseMove}>

                                            {play && <video
                                                ref={videoRef}
                                                className="w-100 d-block pb-0"
                                                // controls
                                                autoPlay
                                                playsInline
                                                preload="metadata"
                                                onClick={pauseVideo}
                                                onEnded={pauseVideo}
                                                style={{ aspectRatio: module?.quadratisches_Bild ? '1/1' : '1620/810.5' }}
                                            >
                                                <source
                                                    src={`https://backend.bgzurlinden.ch${module?.Video?.url}`}
                                                    type="video/mp4"
                                                />
                                            </video>}

                                            {hovering && play && (
                                                <div
                                                    className="video_image_cursor"
                                                    style={{
                                                        left: `${position.x}px`,
                                                        top: `${position.y}px`,
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                                        <path d="M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60Z" fill={`var(--orange)`} fill-opacity="1" />
                                                        <rect x="47" y="38" width="8" height="45" fill="white" />
                                                        <rect x="66" y="38" width="8" height="45" fill="white" />
                                                    </svg>
                                                </div>
                                            )}

                                            {!play && (
                                                <>
                                                    <img
                                                        src={`https://backend.bgzurlinden.ch${module?.Videominiaturansicht?.url}`}
                                                        alt=''
                                                        className='video_overlay_img'
                                                        style={{ aspectRatio: module?.quadratisches_Bild ? '1/1' : '1620/810.5' }}
                                                    />

                                                    <button
                                                        type='button'
                                                        onClick={playVideo}
                                                        className='video_play_btn'
                                                    >
                                                        <svg className='icon_play' xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                                            <circle cx="60" cy="60" r="60" fill={`var(--orange)`} />
                                                            <path d="M83 60L43 83L43 37L83 60Z" fill="white" />
                                                        </svg>
                                                    </button>
                                                </>
                                            )}

                                        </div>
                                    ) : (module?.Bilder?.length > 0 &&
                                        <img src={`https://backend.bgzurlinden.ch${module?.Bild_oder_Video === "Video" ? module?.Videominiaturansicht?.url : module?.Bilder[0]?.url}`} alt='#' />
                                    )}
                                </div>
                            </section>
                        }
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}

            <section className='sec-related-aktuelles sec-orange-color pt-pb-10 sec-subtitle-black'>
                <div className='container'>
                    <div className='sec-title'>
                        <div className='subtitle'>Aktuelles</div>
                        {/* <h2 className="mb-3 text-darkgrey">Neueste Aktuelles</h2> */}
                    </div>
                    <div className="row aktuelles_tabs">
                        {aktuelles?.filter((category) => category.slug !== title)?.slice(0, 3).map((aktuelle, index) => {
                            const banner = aktuelle?.Bannerbereich?.[0];
                            const module = aktuelle?.Modul?.[0];

                            return (
                                <div key={index} className="col-sm-6 col-lg-4 col-item mt-4">
                                    <Link to={`/aktuelles/${aktuelle?.slug}`} className='col-inner'>
                                        <figure>
                                            <img src={`https://backend.bgzurlinden.ch${module?.Bild[0].url}`} alt='#' />
                                            <span className={`bg-${aktuelle?.aktuelles_kategorie?.Farbe?.split(" ")[0]}`}>{aktuelle?.aktuelles_kategorie?.Titel}</span>
                                        </figure>
                                        <div className='figcaption'>
                                            <h4 className="fs_26 fw-550 text-darkgrey">{aktuelle?.Titel}</h4>
                                            {banner?.Beschreibung && (
                                                <p>{truncateBlocks(banner.Beschreibung, 70)}</p>
                                            )}
                                            <div className="btn_date_flex">
                                                <div className="button round_btn btn-blue-color">lesen &nbsp;
                                                    <span>
                                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                                                            <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <span className='post-date'>
                                                    {new Date(aktuelle?.Publikation).toLocaleDateString('de-DE', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                    })}
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>
        </div>
    )
}